import clsx from 'clsx';
import { observer } from 'mobx-react';
import { NavLink } from 'react-router-dom';
import { T } from '../../../../../Translations';
import BigCheckmarkCircleIcon from '../../../../Cutesies/BigCheckmarkCircleIcon';

interface Props {
  length: number;
  label: string;
}

function AddParticipantsToGroupSuccess({ length, label }: Props) {
  return (
    <div className="flex flex-col items-center justify-center">
      <BigCheckmarkCircleIcon width="160" height="160" />
      <h2 className="my-4 text-2xl font-bold">
        <T kind="Participants Added" />
      </h2>
      <p className="text-sm my-4">
        <T kind="You added {{count}} participant to {{name}}." count={length} name={label} />
      </p>
      <NavLink
        to={'/people'}
        className={clsx(
          'px-4 py-3 my-8',
          'rounded-md bg-teal-600',
          'text-white text-sm',
          'cursor-pointer',
          'text-center mx-auto',
        )}
      >
        <T kind="Done" />
      </NavLink>
      <NavLink to={'/people'} className="block text-center text-sm font-semibold text-teal-600">
        <T kind="Back to all people" />
      </NavLink>
    </div>
  );
}

export default observer(AddParticipantsToGroupSuccess);
